module.exports = __webpack_public_path__ + "static/media/IMG_9987.c365e5c5.jpg";